<email-header></email-header>

<div class="section-loader" *ngIf="isLoggingIn() && !isLoggedIn()">
    <app-loader style="position: relative;top:-125px;"></app-loader>
</div>
<div *ngIf="isLoggedIn()">
    <app-profile-user-summary></app-profile-user-summary>
    <app-profile-tablist></app-profile-tablist>
</div>
<app-navigation></app-navigation>